import React, { useState } from 'react';
import {
    Box,
    TextField,
    Button,
    Typography,
    Paper,
    Alert,
    CircularProgress,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { forgotPassword } from '../../services/authService';
import { useNavigate } from 'react-router-dom';
import { assetPath } from '../../utils/constants';

const ForgotPassword = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const navigate = useNavigate();
    
    const { register, handleSubmit, formState: { errors } } = useForm();

    const onSubmit = async (data) => {
        setLoading(true);
        try {
            const response = await forgotPassword(data.email);            
            if (response.responseCode === 1) {
                setSuccess(response.responseMessage);
                setTimeout(() => {
                    navigate('/login');
                }, 3000);
            } else {
                setError('Failed to process password reset request');
            }
            setError('');
        } catch (err) {
            setError(err.response?.data?.message || 'An error occurred while processing your request');
            setSuccess('');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundImage: `url("${assetPath('backgroundImage.png')}")`, backgroundSize: 'cover',  backgroundPosition: 'center', backgroundRepeat: 'no-repeat',  }}>
            <Paper elevation={3} sx={{ p: 4, width: '100%', maxWidth: '400px' }}>
            <Box
                    component="img"
                    src={assetPath('Logo.png')}
                    alt="Logo"
                    sx={{
                        width: '150px', 
                        height: 'auto',
                        marginBottom: 2
                    }}
                />
                <Typography component="h1" variant="h5" sx={{ mb: 3 }}>
                    Forgot Password
                </Typography>

                {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

                <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email Address"
                        autoComplete="email"
                        autoFocus
                        {...register('email', {
                            required: 'Email is required',
                            pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: 'Invalid email address'
                            }
                        })}
                        error={!!errors.email}
                        helperText={errors.email?.message}
                    />

                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3 }}
                        disabled={loading}
                    >
                        {loading ? <CircularProgress size={24} /> : 'Reset Password'}
                    </Button>

                    <Button
                        fullWidth
                        variant="text"
                        sx={{ mt: 2 }}
                        onClick={() => navigate('/login')}
                    >
                        Back to Login
                    </Button>
                </Box>
            </Paper>
        </Box>
    );
};

export default ForgotPassword;